import React from 'react'
// Field behavior copied from the storefront AuthRegistration components.

import styles from '../AuthRegistration.module.scss'

export default function AuthTextField({
  id,
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
  inputMode,
  maxLength,
  max,
  error,
  disabled,
  required,
  autoFocus,
}) {
  const errorId = error ? `${id}-error` : undefined
  const hasValue = Boolean(value)

  return (
    <div className={styles.fieldBlock}>
      <div
        className={[styles.field, hasValue ? styles.fieldWithValue : '', error ? styles.fieldInvalid : '']
          .filter(Boolean)
          .join(' ')}
      >
        <input
          id={id}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          inputMode={inputMode}
          maxLength={maxLength}
          max={max}
          disabled={disabled}
          required={required}
          aria-required={required ? true : undefined}
          autoFocus={autoFocus}
          aria-invalid={error ? true : undefined}
          aria-describedby={errorId}
          placeholder=" "
        />
        <label htmlFor={id}>{label}</label>
      </div>
      {error ? (
        <p className={styles.fieldError} id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  )
}
